// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Tooltip = require("../../common/Components/Tooltip.bs.js");
let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let FragmentErrorBoundary = require("../../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let ToggleMatchDismissButtonMutation_graphql = require("../../../__generated__/ToggleMatchDismissButtonMutation_graphql.bs.js");
let ToggleMatchDismissButton_matchV5_graphql = require("../../../__generated__/ToggleMatchDismissButton_matchV5_graphql.bs.js");
let ToggleMatchDismissButton_UndismissMatchMutation_graphql = require("../../../__generated__/ToggleMatchDismissButton_UndismissMatchMutation_graphql.bs.js");

let context = React.createContext(undefined);

let make = context.Provider;

function use() {
  return React.useContext(context);
}

let ConnectionContext = {
  context: context,
  make: make,
  use: use
};

let convertFragment = ToggleMatchDismissButton_matchV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ToggleMatchDismissButton_matchV5_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ToggleMatchDismissButton_matchV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ToggleMatchDismissButton_matchV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ToggleMatchDismissButton_matchV5_graphql.node, convertFragment, fRef);
}

let Fragment_matchStatusChangeForbiddenReson_decode = ToggleMatchDismissButton_matchV5_graphql.Utils.matchStatusChangeForbiddenReson_decode;

let Fragment_matchStatusChangeForbiddenReson_fromString = ToggleMatchDismissButton_matchV5_graphql.Utils.matchStatusChangeForbiddenReson_fromString;

let Fragment = {
  matchStatusChangeForbiddenReson_decode: Fragment_matchStatusChangeForbiddenReson_decode,
  matchStatusChangeForbiddenReson_fromString: Fragment_matchStatusChangeForbiddenReson_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = ToggleMatchDismissButtonMutation_graphql.Internal.convertVariables;

let convertResponse = ToggleMatchDismissButtonMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = ToggleMatchDismissButtonMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ToggleMatchDismissButtonMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables, ToggleMatchDismissButtonMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

let convertVariables$1 = ToggleMatchDismissButton_UndismissMatchMutation_graphql.Internal.convertVariables;

let convertResponse$1 = ToggleMatchDismissButton_UndismissMatchMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = ToggleMatchDismissButton_UndismissMatchMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, ToggleMatchDismissButton_UndismissMatchMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$3 = RescriptRelay_Mutation.useMutation(convertVariables$1, ToggleMatchDismissButton_UndismissMatchMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let UndismissMatchMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$3
};

function disabledWrapper(label, children) {
  return JsxRuntime.jsx(Tooltip.make, {
    label: label,
    children: JsxRuntime.jsx("span", {
      children: children
    })
  });
}

function ToggleMatchDismissButton$WithoutErrorBoundary(props) {
  let __onClick = props.onClick;
  let onClick = __onClick !== undefined ? __onClick : prim => {};
  let match = RescriptRelay_Fragment.useFragment(ToggleMatchDismissButton_matchV5_graphql.node, convertFragment, props.match);
  let statusChangePolicy = match.statusChangePolicy;
  let id = match.id;
  let dismissed = match.dismissed;
  let match$1 = use$2();
  let dismissMatch = match$1[0];
  let match$2 = use$3();
  let undismissMatch = match$2[0];
  let connectionContext = React.useContext(context);
  let environment = RescriptRelayReact.useEnvironmentFromContext();
  let removeFromConnections = Stdlib_Array.keepSome([Stdlib_Option.map(connectionContext, c => c.currentConnectionId)]);
  let invalidateRelevantConnections = () => {
    if (connectionContext !== undefined) {
      return RescriptRelay.Environment.invalidateAllOfConnection(environment, connectionContext.connectionKey, connectionContext.parentDataId, undefined);
    }
  };
  let match$3 = SystemMessages.useSystemMessages();
  let addMessage = match$3.addMessage;
  let handleError = () => addMessage(SystemMessages.Message.make(undefined, "error", "There was an error dismissing the match. Please try again...", 5000, undefined, undefined));
  let canDismissMatch;
  switch (statusChangePolicy.__typename) {
    case "MatchStatusChangeAllowed" :
      canDismissMatch = true;
      break;
    case "MatchStatusChangeForbidden" :
    case "__unselected" :
      canDismissMatch = false;
      break;
  }
  let onDismissMatch = () => {
    onClick();
    if (dismissed) {
      undismissMatch({
        connections: removeFromConnections,
        matchId: id
      }, undefined, undefined, undefined, (param, param$1) => {
        let undismissMatch = param.undismissMatch;
        if (undismissMatch !== undefined && undismissMatch.__typename === "MatchUndismissed") {
          return invalidateRelevantConnections();
        } else {
          return handleError();
        }
      }, param => handleError(), undefined);
    } else {
      dismissMatch({
        connections: removeFromConnections,
        matchId: id
      }, undefined, undefined, undefined, (param, param$1) => {
        let dismissMatch = param.dismissMatch;
        if (dismissMatch !== undefined && dismissMatch.__typename === "MatchDismissed") {
          return invalidateRelevantConnections();
        } else {
          return handleError();
        }
      }, param => handleError(), undefined);
    }
  };
  let button = JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
    onClick: param => onDismissMatch(),
    disabled: match$1[1] || match$2[1] || !canDismissMatch,
    size: "small",
    children: dismissed ? "Undismiss match" : "Dismiss match"
  });
  switch (statusChangePolicy.__typename) {
    case "MatchStatusChangeAllowed" :
      return button;
    case "MatchStatusChangeForbidden" :
      let tmp = statusChangePolicy.reason;
      if (tmp !== "NOT_MATCH_OWNER") {
        return button;
      }
      let tmp$1;
      switch (match.__typename) {
        case "MatchForBuyerNeedV5" :
          tmp$1 = "a buyer need";
          break;
        case "MatchForRentalNeedV5" :
          tmp$1 = "a rental need";
          break;
        case "MatchForForSalePropertyV5" :
        case "MatchForRentalPropertyV5" :
          tmp$1 = "a property";
          break;
        default:
          tmp$1 = "an entity";
      }
      return disabledWrapper("You can't remove matches for " + tmp$1 + " that you didn't create", button);
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected match status change policy ` + statusChangePolicy._0);
  }
}

let WithoutErrorBoundary = {
  make: ToggleMatchDismissButton$WithoutErrorBoundary
};

function ToggleMatchDismissButton(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "match dismissal policy",
    children: JsxRuntime.jsx(ToggleMatchDismissButton$WithoutErrorBoundary, {
      match: props.match,
      onClick: props.onClick
    })
  });
}

let make$1 = ToggleMatchDismissButton;

exports.ConnectionContext = ConnectionContext;
exports.Fragment = Fragment;
exports.Mutation = Mutation;
exports.UndismissMatchMutation = UndismissMatchMutation;
exports.disabledWrapper = disabledWrapper;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make$1;
/* context Not a pure module */
